import { render, staticRenderFns } from "./BudgetLimit.vue?vue&type=template&id=273902a4&"
import script from "./BudgetLimit.vue?vue&type=script&lang=js&"
export * from "./BudgetLimit.vue?vue&type=script&lang=js&"
import style0 from "./BudgetLimit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports